import { makeStyles } from '@material-ui/core';

const styles = (theme) => ({
  container: {
    minWidth: 800,
    minHeight: 284,
    position: 'relative',
    flexDirection: 'column',
    display: 'flex',
    backgroundColor: theme.colors.modal__background_primary,
    padding: theme.spacing(12)
  },
  closeButton: {
    position: 'absolute',
    right: 10,
    top: 10
  },
  title: {
    color: theme.colorPalette.green_75,
    fontSize: 40,
    lineHeight: '56px',
    fontWeight: 300,
    padding: 0,
    width: '100%'
  },
  text: {
    color: theme.colors.green_80,
    marginTop: 0,
    fontSize: 16
  },
  stateLabel: {
    padding: theme.spacing(0, 0, 2)
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  closeButtonWithText: {
    width: '94px',
    fontSize: '16px',
    marginLeft: theme.spacing(4)
  },
  priorPolicyButton: {
    width: 180,
    fontSize: 16
  },
  separator: {
    width: '100%',
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(4),
    height: 1,
    borderTop: '2px solid',
    borderColor: theme.colorPalette.beige_50
  }
});

export default makeStyles(styles);
